import { useMemo } from 'react';

import useServiceLevelsStore from './useServiceLevelsStore';
import serviceLevelsPostProcessor from '../helpers/serviceLevelPostProcessor';
import { validationErrorParser } from '@/helpers/beErrorMsgParser';
import usePaginatedTableData from '@/hooks/usePaginatedTableData';

const parsingOptions = {
  errorParser: validationErrorParser,
  trackError: false,
};

const useGetServiceLevelsPaginated = () => {
  const dispatch = useServiceLevelsStore((state) => state.dispatch);
  const offset = useServiceLevelsStore((state) => state.offset);
  const pageSize = useServiceLevelsStore((state) => state.pageSize);

  // Used to trigger refresh when needed
  const refreshKey = useServiceLevelsStore((state) => state.refreshKey);

  const queryParams = useMemo(
    () => ({
      'list_request.page_size': pageSize,
      'list_request.page_offset': offset,
      // Useless attribute, but allows to trigger refresh when needed
      refresh_key: refreshKey,
    }),
    [pageSize, offset, refreshKey]
  );

  usePaginatedTableData({
    params: {
      path: '/service_levels',
      method: 'get',
      reducer: serviceLevelsPostProcessor,
    },
    dispatch,
    queryParams,
    queryParamsOptions: { skipEmptyString: true },
    service: 'deviceV3',
    errorParsingOptions: parsingOptions,
  });
};

export default useGetServiceLevelsPaginated;
